(function () {
  'use strict';

  var STORAGE_KEY = 'commbi_gender';
  var html = document.documentElement;

  function currentGender() {
    if (html.classList.contains('commbi-gender-mens')) return 'mens';
    return 'womens';
  }

  function applyGender(gender, opts) {
    opts = opts || {};
    if (gender !== 'mens' && gender !== 'womens') return;

    html.classList.remove('commbi-gender-mens', 'commbi-gender-womens');
    html.classList.add('commbi-gender-' + gender);

    try { localStorage.setItem(STORAGE_KEY, gender); } catch (e) {}

    if (opts.updateUrl !== false) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('g', gender);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    document.querySelectorAll('[data-commbi-gender-toggle] .commbi-gender-btn').forEach(function (btn) {
      var on = btn.dataset.gender === gender;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    document.dispatchEvent(new CustomEvent('commbi:gender-change', { detail: { gender: gender } }));
  }

  function bind() {
    var toggles = document.querySelectorAll('[data-commbi-gender-toggle]');
    if (!toggles.length) return;

    var active = currentGender();
    toggles.forEach(function (toggle) {
      toggle.querySelectorAll('.commbi-gender-btn').forEach(function (btn) {
        if (btn.dataset.commbiBound === '1') return;
        btn.dataset.commbiBound = '1';

        var on = btn.dataset.gender === active;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');

        btn.addEventListener('click', function () {
          applyGender(btn.dataset.gender);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  // Re-bind after Shopify section reloads (theme editor preview, app blocks)
  document.addEventListener('shopify:section:load', bind);
})();